var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"404"},[_c('h1',[_vm._v("404")]),_c('h2',[_vm._v("页面未找到")]),_c('div',{staticClass:"errorLine"}),_c('p',{staticClass:"backHomeBox"},[_c('router-link',{staticClass:"backHome",attrs:{"to":"/home"}},[_vm._v("返回首页")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }